import { Component, ViewChild } from '@angular/core';

import { DeviceService } from '../../../core/services/device/device.service';
import { WindowRefService } from '../../../core/services/windowRef/window-ref.service';
import { LocaleDirective } from '../../directives/locale.directive';
import { ModalComponent } from '../customModal/custom-modal.component';
import { AbstractDialogComponent } from '../oxygenDialogs/abstract-dialog';

@Component({
    selector: 'connection-lost-dialog',
    templateUrl: 'connection-lost-dialog.component.html',
    styleUrls: ['connection-lost-dialog.component.scss'],
    imports: [ModalComponent, LocaleDirective],
})
export class ConnectionLostDialogComponent extends AbstractDialogComponent {
    @ViewChild('connectionLostDialog', { static: true }) override dialog: any;

    constructor(device: DeviceService, windowRef: WindowRefService) {
        super(device, windowRef);
    }
}
